import { NavLink } from 'react-router-dom';
import HeaderBar from '../components/headerBar';
import { Outlet } from 'react-router';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useClassManagementContext } from '../utils/classManagementContext';
const ClassManagement = () => {
  const items = [
    {
      id: 1,
      name: 'Class Management',
      path: 'classManagement'
    },
    {
      id: 2,
      name: 'Access Rights',
      path: 'acessRights',
    }
  ];

  const { selectedCourseId } = useClassManagementContext();


  return (
    <>
      <HeaderBar
        showCourseHelpIcon={true}
        showAllCourses={true}
      />
      <div className="white-card mt-4">
        <div className="row message-tab align-items-center mb-3">
          <div className="col-xl-11">
            <div className="primary-tab d-md-block mb-md-0">
              <div className="btn-group">
                {items.map((item) => (
                  <>
                    {item.id == 2 && (!selectedCourseId || selectedCourseId<=0)  &&
                    <OverlayTrigger
                      key={`tab${item.id}`}
                      placement="top"
                      overlay={
                        <Tooltip className="initial-assignment-tooltip">
                          <div>
                          Please select a course to enable access rights
                          </div>
                        </Tooltip>
                      }>
                      <span
                        key={item.id}
                        className="btn"
                      >
                        {item.name}
                      </span>
                    </OverlayTrigger>
                    }
                    {(item.id != 2 || (selectedCourseId && selectedCourseId>0))  &&
                    <NavLink
                      key={item.id}
                      className="btn"
                      to={item.path}
                    >
                      {item.name}
                    </NavLink>
                    }
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default ClassManagement;